
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class XlmjTable extends Vue {
    //流水记录类型:
    //1点杠(刮风) 2被点杠(刮风) 3补杠(刮风) 4被补杠(刮风) 5暗杠(下雨) 6被暗杠(下雨) 7自摸 8被自摸 9胡(点炮赢了)
    //10点炮(点炮输了) 11被查大叫<主动退钱> 12查大叫 13被查花猪<主动退钱> 14查花猪 15退税<主动退钱> 16被退税 17服务费
    account_type_list = ['点杠', '被点杠', '补杠', '被补杠', '暗杠', '被暗杠', '自摸', '被自摸', '胡', '点炮', '被查大叫', '查大叫', '被查花猪', '查花猪', '退税', '被退税', '']
    //二人麻将
    table = {
        data: [],
        column: [
            {
                key: 'uid',
                title: '玩家ID',
                align: 'center',
                minWidth: 100,
                render: (h, params) => {
                    let str = bulidUid(params.row.uid)
                    return h('div', [
                        h('p', str),
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red'
                                }
                            },
                            String(params.row.uid).indexOf(String(params.row.user_id)) > -1 ? '(查询玩家)' : ''
                        )
                    ])
                }
            },
            {
                key: 'base_point',
                title: '底分',
                align: 'center',
                minWidth: 50,
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.base_point))
                }
            },
            {
                key: 'WinType',
                title: '胡牌情况',
                align: 'center',
                minWidth: 80,
                render: (h, params) => {
                    let str = ''
                    if (params.row.data.Accounts) {
                        params.row.data.Accounts.map((item) => {
                            if (item.account_type == 17) {
                                return
                            } else {
                                str += this.account_type_list[item.account_type - 1] + '<br>'
                            }
                        })
                    }
                    return h('div', {
                        domProps: {
                            innerHTML: str
                        }
                    })
                }
            },
            {
                key: 'Bet',
                title: '番数情况',
                align: 'center',
                minWidth: 150,
                render: (h, params) => {
                    let str = ''
                    if (params.row.data.Accounts) {
                        params.row.data.Accounts.map((temp) => {
                            let strarr = ''
                            if (temp.fan_detail) {
                                let key = Object.keys(temp.fan_detail)
                                key.map((item) => {
                                    strarr += this.getType(item) + temp.fan_detail[item] + '番' + '、'
                                })
                            }
                            str += strarr.substring(0, strarr.length - 1) + '<br>'
                        })
                    }
                    return h('div', {
                        domProps: {
                            innerHTML: str
                        }
                    })
                }
            },
            {
                key: 'RealAWard',
                title: '输赢金额',
                align: 'center',
                minWidth: 60,
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.data.RealAWard))
                }
            },
            {
                key: 'PercentPoint',
                title: '税收金额',
                align: 'center',
                minWidth: 60,
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.data.PercentPoint))
                }
            },
            {
                key: 'banker',
                title: '游戏身份',
                align: 'center',
                minWidth: 55,
                render: (h, params) => {
                    return h('span', params.row.uid == params.row.banker ? '庄' : '闲')
                }
            },
            {
                key: 'Bet',
                title: '牌面情况',
                minWidth: 460,
                render: (h, params) => {
                    let arr = params.row.data.C || [] //剩余牌面
                    let arr3 = params.row.data.SetCards || [] //吃/碰/杠牌数据
                    let dataArr: any = []
                    arr3.forEach((item, index) => {
                        let subArr = item.AllCards
                        let show = false
                        let red = item.Card
                        let one = true
                        subArr.forEach((subitem, subindex) => {
                            if (subitem == red && one) {
                                //显示红框
                                show = true
                                one = false
                                dataArr.push({ card: subitem, show: show, type: item.Type })
                            } else {
                                //不显示
                                show = false
                                dataArr.push({ card: subitem, show: show, type: item.Type })
                            }
                        })
                        if (index != arr3.length - 1) {
                            //间隔
                            dataArr.push({ card: '', show: '' })
                        }
                    })
                    return h('div', [
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: dataArr.map((x, index) => {
                                    let str = ''
                                    if (index == 0) {
                                        str = '<span style="margin-left:5px;">吃、碰、杠牌数据：</span>'
                                    }
                                    if (x.card != '') {
                                        if (x.show) {
                                            return str + "<img style='width:25px;color: #f92f26; border: 2px solid; border-radius: 6px;' src=img/poker/MJ/mingmah_" + (x.card + 10) + '.png>'
                                        } else {
                                            if (x.type == 6) {
                                                return str + "<img style='width:25px;' src=img/poker/MJ/mingmah_" + 0 + '.png>'
                                            }
                                            return str + "<img style='width:25px;' src=img/poker/MJ/mingmah_" + (x.card + 10) + '.png>'
                                        }
                                    } else {
                                        return '&nbsp;&nbsp;'
                                    }
                                })
                            }
                        }),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: params.row.data.WinCards.map((x, index) => {
                                    let str = ''
                                    if (index == 0) {
                                        str = "<span style='margin-left: 20px;'>胡牌：</span>"
                                    }
                                    return str + "<img style='width:" + (x >= 1000 ? 28 : 25) + "px;' src=img/poker/MJ/mingmah_" + ((x >= 1000 ? x / 1000 : x) + 10) + '.png>'
                                })
                            }
                        }),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: arr.map((x, index) => {
                                    let str = ''
                                    if (index == 0) {
                                        str = '<span style="margin-left:5px;">手牌：</span>'
                                    }
                                    return str + "<img style='width:25px;' src=img/poker/MJ/mingmah_" + (x + 10) + '.png>'
                                })
                            }
                        })
                    ])
                }
            }
        ]
    }
    getListData() {
        if (this.listdata[0].opt_detail == 'null') {
            return (this.table.data = [])
        } else {
            let obj3 = JSON.parse(this.listdata[0].opt_detail).users
            let list = JSON.parse(this.listdata[0].opt_detail)
            let arr3: any = []
            for (let i in obj3) {
                let Object = {
                    user_id: this.listdata[0].user_id,
                    base_point: list.base_point, //底分
                    banker: list.banker, //庄家UID
                    uid: i, //每个玩家id
                    data: obj3[i]
                }
                arr3.push(Object)
            }
            return arr3
        }
    }
    //二人麻将番型
    getType(num) {
        let ermjObj = {
            '1075': '清十八罗汉',
            '1074': '十八罗汉',
            '1073': '清龙七对',
            '1072': '清金钩钓',
            '1071': '清七对',
            '1070': '龙七对',
            '1069': '清碰',
            '1068': '金钩钓',
            '1020': '七对',
            '1021': '清一色',
            '1035': '碰碰胡',
            '1066': '根',
            '1031': '海底捞月',
            '1033': '杠上开花',
            '1034': '抢杠胡',
            '1064': '自摸',
            '1067': '杠上炮',
            '1065': '平胡'
        }
        return ermjObj[num]
    }

    @Prop()
    listdata
}
